import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bar_chart_race_data:null,
    sunburst_data:null,
    countries_map:null,
    total_data:null,
    year2019_data:null,
    movie_tv:null,
    netflix_titles:null,
    netflix_titles2:null,
    netflix_titles3:null,
    tree_data:null,
    top20_data: null
  },
  mutations: {
    bar_chart_race_data(state,payload){
      state.bar_chart_race_data=payload;
    },
    sunburst_data(state,payload){
      state.sunburst_data=payload;
    },
    countries_map(state,payload){
      state.countries_map=payload;
    },
    total_data(state,payload){
      state.total_data=payload;
    },
    
    year2019_data(state,payload){
      state.year2019_data=payload;
    },
    movie_tv(state,payload){
      state.movie_tv=payload;
    },
    netflix_titles(state,payload){
      state.netflix_titles=payload;
    },
    netflix_titles2(state,payload){
      state.netflix_titles2=payload;
    },
    netflix_titles3(state,payload){
      state.netflix_titles3=payload;
    },
    tree_data(state,payload){
      state.tree_data=payload;
    },
    top20_data(state,payload){
      state.top20_data=payload;
    },
  },
  actions: {
  },
  modules: {
  }
})
